jQuery(document).ready(function($) {

  'use strict';

  
  /* Supplement Facts Overlay */
  
  $('.supplement-facts-link').on('click', function(e) {
    e.preventDefault(); 
    $('.nr-overlay-supplement-facts').addClass('is-visible');
    $('body').addClass('no-scroll');
  });

  $('.nr-close-overlay').on('click', function(e) {
    e.preventDefault(); 
	$('.nr-overlay-supplement-facts').removeClass('is-visible');
    $('body').removeClass('no-scroll');
  });
	  
  
  /* Supplement Facts Overlay */
  var productThumbWidth = $('.product-medias__thumbnails').find('.product-medias__thumbnail').width();
  $('.product-medias__thumbnails').find('.product-medias__thumbnail').css({
    'height': productThumbWidth,
    'overflow': 'hidden'
  });
  $(window).on('resize', function() {
    productThumbWidth = $('.product-medias__thumbnails').find('.product-medias__thumbnail').width();
    $('.product-medias__thumbnails').find('.product-medias__thumbnail').css({
      'height': productThumbWidth,
      'overflow': 'hidden'
    });
  });
  
  /* Guide Overlay */
  
  $('.guide-link').on('click', function(e) {
    e.preventDefault(); 
    $('.nr-overlay-guide').addClass('is-visible');
    $('body').addClass('no-scroll');
  });

  $('.nr-close-overlay').on('click', function(e) {
    e.preventDefault(); 
	$('.nr-overlay-guide').removeClass('is-visible');
    $('body').removeClass('no-scroll');
  });
	  
  var productThumbWidth = $('.product-medias__thumbnails').find('.product-medias__thumbnail').width();
  $('.product-medias__thumbnails').find('.product-medias__thumbnail').css({
    'height': productThumbWidth,
    'overflow': 'hidden'
  });
  $(window).on('resize', function() {
    productThumbWidth = $('.product-medias__thumbnails').find('.product-medias__thumbnail').width();
    $('.product-medias__thumbnails').find('.product-medias__thumbnail').css({
      'height': productThumbWidth,
      'overflow': 'hidden'
    });
  });
  
  
  /* Reviews Overlay */
  
  $('.reviews-link').on('click', function(e) {
    e.preventDefault(); 
    $('.nr-overlay-reviews').addClass('is-visible');
    $('body').addClass('no-scroll');
  });

  $('.nr-close-overlay').on('click', function(e) {
    e.preventDefault(); 
	$('.nr-overlay-reviews').removeClass('is-visible');
    $('body').removeClass('no-scroll');
  });
	  
  
  /* Reviews Overlay */
  var productThumbWidth = $('.product-medias__thumbnails').find('.product-medias__thumbnail').width();
  $('.product-medias__thumbnails').find('.product-medias__thumbnail').css({
    'height': productThumbWidth,
    'overflow': 'hidden'
  });
  $(window).on('resize', function() {
    productThumbWidth = $('.product-medias__thumbnails').find('.product-medias__thumbnail').width();
    $('.product-medias__thumbnails').find('.product-medias__thumbnail').css({
      'height': productThumbWidth,
      'overflow': 'hidden'
    });
  });
  
  
  
  
  
  
  
  
  /* Add To Cart Submit */   
  $('.nr-addtocart-wrapper a').on('click', function(e) {
  	e.preventDefault();
    $(this).parents('form').submit();
  });
  $('.nr-addtocart-link').on('click', function(e) {
  	e.preventDefault();
    $('#AddToCartForm').submit();
  });
  
  
  
  var qtyVal = $('.nr-page-product-form .js-qty__num').val();
  
  $('.nr-page-product-form .js-qty__adjust--plus').on('click', function() {
    qtyVal = +$('.nr-page-product-form .js-qty__num').val() + 1;
	$('.nr-page-product-form .js-qty__num').val(qtyVal);   
  });
  
  $('.nr-page-product-form .js-qty__adjust--minus').on('click', function() {
    if( qtyVal > 1 ) {
      qtyVal = $('.nr-page-product-form .js-qty__num').val() - 1;
      $('.nr-page-product-form .js-qty__num').val(qtyVal);
    }
  });
  
  
  
  $('.nr-page-add-to-cart').on('click',function() {
    
    var quantity = $('.nr-page-product-form .js-qty__num').val();
    quantity = parseInt(quantity);
    console.log(quantity)

    var id = '32558720974907';
    
    $.ajax({
      type: 'POST', 
      url: '/cart/add.js',
      dataType: 'json', 
      data: {id:id, quantity: quantity},
      success: function(){
        location.href='/cart';
      }
    });
    
  });
  

  
  /* ==================================================================================
    Accordion
  ==================================================================================*/
  
  $('.nr-accordion-title').on('click', function(e) {
    e.preventDefault();
    $(this).parents('.nr-accordion-item').toggleClass('nr-accordion-item-open');
  });
  
  $('.nr-journey-accordion-title').on('click', function(e) {
    e.preventDefault();
    $(this).parents('.nr-journey-accordion-item').toggleClass('nr-journey-accordion-item-open');
  });

  
  
  /* ==================================================================================
    Flexslider
  ==================================================================================*/
  
  $('.flexslider').flexslider({
    animation: 'slide',
    controlNav: false,
    directionNav: false
  });
  
  
  /* ==================================================================================
    Team Carousel
  ==================================================================================*/
  
  $(window).on('load', function() {
    $('.nr-team-carousel').slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      prevArrow: '<a href="#" class="nr-prev-arrow"><span class="material-icons">chevron_left</span></a>',
      nextArrow: '<a href="#" class="nr-next-arrow"><span class="material-icons">chevron_right</span></a>',
      responsive: [
        {
          breakpoint: 1280,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 960,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });    
  });
  
  $(window).on('load', function() {
    $('.hero-carousel').slick({
      infinite: true,
      slidesToShow: 1,
      autoplay: false,
      autoplaySpeed: 5000,
      arrows: false,
      dots: false,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 1280,
          settings: {
            slidesToShow: 1
          }
        },
        {
          breakpoint: 960,
          settings: {
            slidesToShow: 1
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
  });
  
  
  
  /* ==================================================================================
  	 Smooth Scroll Anchor Links
  ==================================================================================*/
  
  $('a[href*="#"]')
  // Remove links that don't actually link to anything
  .not('[href="#"]')
  .not('[href="#0"]')
  .click(function(event) {
    // On-page links
    if (
      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
      && 
      location.hostname == this.hostname
    ) {
      // Figure out element to scroll to
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      // Does a scroll target exist?
      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
        $('html, body').animate({
          scrollTop: target.offset().top
        }, 1000, function() {
          // Callback after animation
          // Must change focus!
          var $target = $(target);
          $target.focus();
          if ($target.is(":focus")) { // Checking if the target was focused
            return false;
          } else {
            $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
            $target.focus(); // Set focus again
          };
        });
      }
    }
  });
  
  var berryCount = 8; var berryImage = "url(https://cdn.shopify.com/s/files/1/0324/0640/5179/files/berries.jpg?v=1632926330)";
  var fishCount = 3; var fishImage = "url(https://cdn.shopify.com/s/files/1/0324/0640/5179/files/fish.jpg?v=1632926322)";
  var teaCount = 14; var teaImage = "url(https://cdn.shopify.com/s/files/1/0324/0640/5179/files/teas.jpg?v=1632926316)";
  var greenCount = 14; var greenImage = "url(https://cdn.shopify.com/s/files/1/0324/0640/5179/files/greens.jpg?v=1632926326)";
  var nutsCount = 12; var nutsImage = "url(https://cdn.shopify.com/s/files/1/0324/0640/5179/files/nuts.jpg?v=1632926319)";
  
  var berryValue = $( "select.berries option:checked" ).val();
    var percentage = (berryValue / berryCount) * 100;
    if(percentage > 100){ percentage = 100; }
    $('.berry-graph').attr('style','background: linear-gradient(360deg, #214232 ' + percentage +'%, rgba(229, 212, 197, 0) 0% 0%), ' + berryImage);
  	$('.berry-graph-inner').attr('style','background: linear-gradient(360deg, #214232 ' + percentage +'%, rgba(229, 212, 197, .5) 0% 0%)');
  	$('.berry-percentage').html(Math.round(percentage) + '%');
  var fishValue = $( "select.fish option:checked" ).val();
    var percentage = (fishValue / fishCount) * 100;
  	if(percentage > 100){ percentage = 100; }
    $('.fish-graph').attr('style','background: linear-gradient(360deg, #214232 ' + percentage +'%, rgba(229, 212, 197, 0) 0% 0%), ' + fishImage);
  	$('.fish-graph-inner').attr('style','background: linear-gradient(360deg, #214232 ' + percentage +'%, rgba(229, 212, 197, .5) 0% 0%)');
  	$('.fish-percentage').html(Math.round(percentage) + '%');
  var teaValue = $( "select.teas option:checked" ).val();
    var percentage = (teaValue / teaCount) * 100;
  	if(percentage > 100){ percentage = 100; }
    $('.tea-graph').attr('style','background: linear-gradient(360deg, #214232 ' + percentage +'%, rgba(229, 212, 197, 0) 0% 0%), ' + teaImage);
  	$('.tea-graph-inner').attr('style','background: linear-gradient(360deg, #214232 ' + percentage +'%, rgba(229, 212, 197, .5) 0% 0%)');
  	$('.tea-percentage').html(Math.round(percentage) + '%');
  var greenValue = $( "select.greens option:checked" ).val();
    var percentage = (greenValue / greenCount) * 100;
  	if(percentage > 100){ percentage = 100; }
    $('.green-graph').attr('style','background: linear-gradient(360deg, #214232 ' + percentage +'%, rgba(229, 212, 197, 0) 0% 0%), ' + greenImage);
  	$('.green-graph-inner').attr('style','background: linear-gradient(360deg, #214232 ' + percentage +'%, rgba(229, 212, 197, .5) 0% 0%)');
  	$('.green-percentage').html(Math.round(percentage) + '%');
  var nutsValue = $( "select.nuts option:checked" ).val();
    var percentage = (nutsValue / nutsCount) * 100;
  	if(percentage > 100){ percentage = 100; }
    $('.nuts-graph').attr('style','background: linear-gradient(360deg, #214232 ' + percentage +'%, rgba(229, 212, 197, 0) 0% 0%), ' + nutsImage);
  	$('.nuts-graph-inner').attr('style','background: linear-gradient(360deg, #214232 ' + percentage +'%, rgba(229, 212, 197, .5) 0% 0%)');
  	$('.nuts-percentage').html(Math.round(percentage) + '%');
  
  $('.berries').change(function() {
    var berryValue = $( "select.berries option:checked" ).val();
    var percentage = (berryValue / berryCount) * 100;
    if(percentage > 100){ percentage = 100; }
    $('.berry-graph').attr('style','background: linear-gradient(360deg, #214232 ' + percentage +'%, rgba(229, 212, 197, 0) 0% 0%), ' + berryImage);
  	$('.berry-graph-inner').attr('style','background: linear-gradient(360deg, #214232 ' + percentage +'%, rgba(229, 212, 197, .5) 0% 0%)');
    $('.berry-percentage').html(Math.round(percentage) + '%');
  });
  
  $('.fish').change(function() {
    var fishValue = $( "select.fish option:checked" ).val();
    var percentage = (fishValue / fishCount) * 100;
    if(percentage > 100){ percentage = 100; }
    $('.fish-graph').attr('style','background: linear-gradient(360deg, #214232 ' + percentage +'%, rgba(229, 212, 197, 0) 0% 0%), ' + fishImage);
  	$('.fish-graph-inner').attr('style','background: linear-gradient(360deg, #214232 ' + percentage +'%, rgba(229, 212, 197, .5) 0% 0%)');
    $('.fish-percentage').html(Math.round(percentage) + '%');
  });
  
  $('.teas').change(function() {
    var teaValue = $( "select.teas option:checked" ).val();
    var percentage = (teaValue / teaCount) * 100;
    if(percentage > 100){ percentage = 100; }
    $('.tea-graph').attr('style','background: linear-gradient(360deg, #214232 ' + percentage +'%, rgba(229, 212, 197, 0) 0% 0%), ' + teaImage);
  	$('.tea-graph-inner').attr('style','background: linear-gradient(360deg, #214232 ' + percentage +'%, rgba(229, 212, 197, .5) 0% 0%)');
    $('.tea-percentage').html(Math.round(percentage) + '%');
  });
  
  $('.greens').change(function() {
    var greenValue = $( "select.greens option:checked" ).val();
    var percentage = (greenValue / greenCount) * 100;
    if(percentage > 100){ percentage = 100; }
    $('.green-graph').attr('style','background: linear-gradient(360deg, #214232 ' + percentage +'%, rgba(229, 212, 197, 0) 0% 0%), ' + greenImage);
  	$('.green-graph-inner').attr('style','background: linear-gradient(360deg, #214232 ' + percentage +'%, rgba(229, 212, 197, .5) 0% 0%)');
    $('.green-percentage').html(Math.round(percentage) + '%');
  });
  
  $('.nuts').change(function() {
    var nutsValue = $( "select.nuts option:checked" ).val();
    var percentage = (nutsValue / nutsCount) * 100;
    if(percentage > 100){ percentage = 100; }
    $('.nuts-graph').attr('style','background: linear-gradient(360deg, #214232 ' + percentage +'%, rgba(229, 212, 197, 0) 0% 0%), ' + nutsImage);
  	$('.nuts-graph-inner').attr('style','background: linear-gradient(360deg, #214232 ' + percentage +'%, rgba(229, 212, 197, .5) 0% 0%)');
    $('.nuts-percentage').html(Math.round(percentage) + '%');
  });
  
  
  

});

  /* Scroll to anchor */
  function pgshow(e){
    var elId = window.location.hash;
    if (elId.length > 1){
      el = document.getElementById(elId.substr(1));
      if (el) el.scrollIntoView(true);
    }
  }
  // pageshow fires after load and on Back/Forward
  window.addEventListener('pageshow', pgshow);

